import { Record } from 'immutable';

const uiRecord = new Record({
  loader: false,
  error: null
});

export default uiRecord;
